module.exports = __webpack_public_path__ + "static/media/myFavouritesList.d2e7a947.svg";